import "./bottombar.scss"

export default function Bottombar() {
    return (
        <div className="bottombar" id="bottombar">
            
        </div>
    )
}
